<template>
  <div class="short-deck-individual-card-selector" v-bind:disabled="disabled">
    <div v-bind:class="popoverDirectionClass">
      <span class="dropdown-toggle" data-toggle="dropdown">
        <img
          v-if="cardString"
          v-bind:src="cardImageSrc"
        >
      </span>
      <div class="dropdown-menu">
        <section class="non-mobile">
          <!-- consider https://iconscout.com/icon-pack/casino-and-gambling-flat/all if I launch -->
          <table>
            <tr>
              <td><img v-if="isCardAvailable('ah')" src="/static/cards/ace-of-hearts.png" v-on:click="select('ah', $event)"></td>
              <td><img v-if="isCardAvailable('kh')" src="/static/cards/king-of-hearts.png" v-on:click="select('kh', $event)"></td>
              <td><img v-if="isCardAvailable('qh')" src="/static/cards/queen-of-hearts.png" v-on:click="select('qh', $event)"></td>
              <td><img v-if="isCardAvailable('jh')" src="/static/cards/jack-of-hearts.png" v-on:click="select('jh', $event)"></td>
              <td><img v-if="isCardAvailable('th')" src="/static/cards/ten-of-hearts.png" v-on:click="select('th', $event)"></td>
              <td><img v-if="isCardAvailable('9h')" src="/static/cards/nine-of-hearts.png" v-on:click="select('9h', $event)"></td>
              <td><img v-if="isCardAvailable('8h')" src="/static/cards/eight-of-hearts.png" v-on:click="select('8h', $event)"></td>
              <td><img v-if="isCardAvailable('7h')" src="/static/cards/seven-of-hearts.png" v-on:click="select('7h', $event)"></td>
              <td><img v-if="isCardAvailable('6h')" src="/static/cards/six-of-hearts.png" v-on:click="select('6h', $event)"></td>
            </tr>
            <tr>
              <td><img v-if="isCardAvailable('as')" src="/static/cards/ace-of-spades.png" v-on:click="select('as', $event)"></td>
              <td><img v-if="isCardAvailable('ks')" src="/static/cards/king-of-spades.png" v-on:click="select('ks', $event)"></td>
              <td><img v-if="isCardAvailable('qs')" src="/static/cards/queen-of-spades.png" v-on:click="select('qs', $event)"></td>
              <td><img v-if="isCardAvailable('js')" src="/static/cards/jack-of-spades.png" v-on:click="select('js', $event)"></td>
              <td><img v-if="isCardAvailable('ts')" src="/static/cards/ten-of-spades.png" v-on:click="select('ts', $event)"></td>
              <td><img v-if="isCardAvailable('9s')" src="/static/cards/nine-of-spades.png" v-on:click="select('9s', $event)"></td>
              <td><img v-if="isCardAvailable('8s')" src="/static/cards/eight-of-spades.png" v-on:click="select('8s', $event)"></td>
              <td><img v-if="isCardAvailable('7s')" src="/static/cards/seven-of-spades.png" v-on:click="select('7s', $event)"></td>
              <td><img v-if="isCardAvailable('6s')" src="/static/cards/six-of-spades.png" v-on:click="select('6s', $event)"></td>
            </tr>
            <tr>
              <td><img v-if="isCardAvailable('ad')" src="/static/cards/ace-of-diamonds.png" v-on:click="select('ad', $event)"></td>
              <td><img v-if="isCardAvailable('kd')" src="/static/cards/king-of-diamonds.png" v-on:click="select('kd', $event)"></td>
              <td><img v-if="isCardAvailable('qd')" src="/static/cards/queen-of-diamonds.png" v-on:click="select('qd', $event)"></td>
              <td><img v-if="isCardAvailable('jd')" src="/static/cards/jack-of-diamonds.png" v-on:click="select('jd', $event)"></td>
              <td><img v-if="isCardAvailable('td')" src="/static/cards/ten-of-diamonds.png" v-on:click="select('td', $event)"></td>
              <td><img v-if="isCardAvailable('9d')" src="/static/cards/nine-of-diamonds.png" v-on:click="select('9d', $event)"></td>
              <td><img v-if="isCardAvailable('8d')" src="/static/cards/eight-of-diamonds.png" v-on:click="select('8d', $event)"></td>
              <td><img v-if="isCardAvailable('7d')" src="/static/cards/seven-of-diamonds.png" v-on:click="select('7d', $event)"></td>
              <td><img v-if="isCardAvailable('6d')" src="/static/cards/six-of-diamonds.png" v-on:click="select('6d', $event)"></td>
            </tr>
            <tr>
              <td><img v-if="isCardAvailable('ac')" src="/static/cards/ace-of-clubs.png" v-on:click="select('ac', $event)"></td>
              <td><img v-if="isCardAvailable('kc')" src="/static/cards/king-of-clubs.png" v-on:click="select('kc', $event)"></td>
              <td><img v-if="isCardAvailable('qc')" src="/static/cards/queen-of-clubs.png" v-on:click="select('qc', $event)"></td>
              <td><img v-if="isCardAvailable('jc')" src="/static/cards/jack-of-clubs.png" v-on:click="select('jc', $event)"></td>
              <td><img v-if="isCardAvailable('tc')" src="/static/cards/ten-of-clubs.png" v-on:click="select('tc', $event)"></td>
              <td><img v-if="isCardAvailable('9c')" src="/static/cards/nine-of-clubs.png" v-on:click="select('9c', $event)"></td>
              <td><img v-if="isCardAvailable('8c')" src="/static/cards/eight-of-clubs.png" v-on:click="select('8c', $event)"></td>
              <td><img v-if="isCardAvailable('7c')" src="/static/cards/seven-of-clubs.png" v-on:click="select('7c', $event)"></td>
              <td><img v-if="isCardAvailable('6c')" src="/static/cards/six-of-clubs.png" v-on:click="select('6c', $event)"></td>
            </tr>
          </table>
          <button
            class="btn btn-default btn-block"
            v-on:click="selectRandomCard($event)"
          >
            Random
          </button>
        </section>
        <section class="mobile">
          <button
            v-if="popoverDirectionClass === 'dropdown'"
            class="btn btn-default btn-block btn-lg"
            v-on:click="selectRandomCard($event)"
          >
            Random
          </button>
          <tr>
            <td><img v-if="isCardAvailable('ah')" src="/static/cards/ace-of-hearts.png" v-on:click="select('ah', $event)"></td>
            <td><img v-if="isCardAvailable('as')" src="/static/cards/ace-of-spades.png" v-on:click="select('as', $event)"></td>
            <td><img v-if="isCardAvailable('ad')" src="/static/cards/ace-of-diamonds.png" v-on:click="select('ad', $event)"></td>
            <td><img v-if="isCardAvailable('ac')" src="/static/cards/ace-of-clubs.png" v-on:click="select('ac', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('kh')" src="/static/cards/king-of-hearts.png" v-on:click="select('kh', $event)"></td>
            <td><img v-if="isCardAvailable('ks')" src="/static/cards/king-of-spades.png" v-on:click="select('ks', $event)"></td>
            <td><img v-if="isCardAvailable('kd')" src="/static/cards/king-of-diamonds.png" v-on:click="select('kd', $event)"></td>
            <td><img v-if="isCardAvailable('kc')" src="/static/cards/king-of-clubs.png" v-on:click="select('kc', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('qh')" src="/static/cards/queen-of-hearts.png" v-on:click="select('qh', $event)"></td>
            <td><img v-if="isCardAvailable('qs')" src="/static/cards/queen-of-spades.png" v-on:click="select('qs', $event)"></td>
            <td><img v-if="isCardAvailable('qd')" src="/static/cards/queen-of-diamonds.png" v-on:click="select('qd', $event)"></td>
            <td><img v-if="isCardAvailable('qc')" src="/static/cards/queen-of-clubs.png" v-on:click="select('ac', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('jh')" src="/static/cards/jack-of-hearts.png" v-on:click="select('jh', $event)"></td>
            <td><img v-if="isCardAvailable('js')" src="/static/cards/jack-of-spades.png" v-on:click="select('js', $event)"></td>
            <td><img v-if="isCardAvailable('jd')" src="/static/cards/jack-of-diamonds.png" v-on:click="select('jd', $event)"></td>
            <td><img v-if="isCardAvailable('jc')" src="/static/cards/jack-of-clubs.png" v-on:click="select('jc', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('th')" src="/static/cards/ten-of-hearts.png" v-on:click="select('th', $event)"></td>
            <td><img v-if="isCardAvailable('ts')" src="/static/cards/ten-of-spades.png" v-on:click="select('ts', $event)"></td>
            <td><img v-if="isCardAvailable('td')" src="/static/cards/ten-of-diamonds.png" v-on:click="select('td', $event)"></td>
            <td><img v-if="isCardAvailable('tc')" src="/static/cards/ten-of-clubs.png" v-on:click="select('tc', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('9h')" src="/static/cards/nine-of-hearts.png" v-on:click="select('9h', $event)"></td>
            <td><img v-if="isCardAvailable('9s')" src="/static/cards/nine-of-spades.png" v-on:click="select('9s', $event)"></td>
            <td><img v-if="isCardAvailable('9d')" src="/static/cards/nine-of-diamonds.png" v-on:click="select('9d', $event)"></td>
            <td><img v-if="isCardAvailable('9c')" src="/static/cards/nine-of-clubs.png" v-on:click="select('9c', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('8h')" src="/static/cards/eight-of-hearts.png" v-on:click="select('8h', $event)"></td>
            <td><img v-if="isCardAvailable('8s')" src="/static/cards/eight-of-spades.png" v-on:click="select('8s', $event)"></td>
            <td><img v-if="isCardAvailable('8d')" src="/static/cards/eight-of-diamonds.png" v-on:click="select('8d', $event)"></td>
            <td><img v-if="isCardAvailable('8c')" src="/static/cards/eight-of-clubs.png" v-on:click="select('8c', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('7h')" src="/static/cards/seven-of-hearts.png" v-on:click="select('7h', $event)"></td>
            <td><img v-if="isCardAvailable('7s')" src="/static/cards/seven-of-spades.png" v-on:click="select('7s', $event)"></td>
            <td><img v-if="isCardAvailable('7d')" src="/static/cards/seven-of-diamonds.png" v-on:click="select('7d', $event)"></td>
            <td><img v-if="isCardAvailable('7c')" src="/static/cards/seven-of-clubs.png" v-on:click="select('7c', $event)"></td>
          </tr>
          <tr>
            <td><img v-if="isCardAvailable('6h')" src="/static/cards/six-of-hearts.png" v-on:click="select('6h', $event)"></td>
            <td><img v-if="isCardAvailable('6s')" src="/static/cards/six-of-spades.png" v-on:click="select('6s', $event)"></td>
            <td><img v-if="isCardAvailable('6d')" src="/static/cards/six-of-diamonds.png" v-on:click="select('6d', $event)"></td>
            <td><img v-if="isCardAvailable('6c')" src="/static/cards/six-of-clubs.png" v-on:click="select('6c', $event)"></td>
          </tr>
          <button
            v-if="popoverDirectionClass === 'dropup'"
            class="btn btn-default btn-block btn-lg"
            v-on:click="selectRandomCard($event)"
          >
            Random
          </button>
        </section>
      </div>
    </div>
    <span class="deselect" v-on:click="$emit('deselect')">
      <span v-if="cardString && !hideDeselect && !disabled">&times;</span>
    </span>
  </div>
</template>

<script>
import constants from '@/services/constants';

export default {
  name: 'short-deck-individual-card-selector',
  props: ['cardString', 'presetCards', 'popoverDirectionClass', 'hideDeselect', 'disabled'],
  computed: {
    cardImageSrc: function () {
      let src = '/static/cards/';
      let cardRank = this.cardString[0];
      let cardSuit = this.cardString[1];

      if (cardRank === 'a') {
        src += 'ace-of-';
      } else if (cardRank === 'k') {
        src += 'king-of-';
      } else if (cardRank === 'q') {
        src += 'queen-of-';
      } else if (cardRank === 'j') {
        src += 'jack-of-';
      } else if (cardRank === 't') {
        src += 'ten-of-';
      } else if (cardRank === '9') {
        src += 'nine-of-';
      } else if (cardRank === '8') {
        src += 'eight-of-';
      } else if (cardRank === '7') {
        src += 'seven-of-';
      } else if (cardRank === '6') {
        src += 'six-of-';
      } else {
        throw new Error('Invalid value for cardRank: ', cardRank);
      }

      if (cardSuit === 'h') {
        src += 'hearts';
      } else if (cardSuit === 'd') {
        src += 'diamonds';
      } else if (cardSuit === 's') {
        src += 'spades';
      } else if (cardSuit === 'c') {
        src += 'clubs';
      } else {
        throw new Error('Invalid value for cardSuit: ', cardSuit);
      }

      src += '.png';
      return src;
    },
  },
  methods: {
    isCardAvailable: function (cardString) {
      if (Number(cardString[0]) < 6) {
        return false;
      }

      return !this.presetCards.includes(cardString);
    },
    select: function (cardString, e) {
      this.$emit('select', {
        card: cardString,
        e: e,
      });
    },
    selectRandomCard: function (e) {
      let randomCard;

      while (!randomCard) {
        randomCard = this._getRandomCard();

        if (!this.isCardAvailable(randomCard)) {
          randomCard = null;
        }
      }

      this.$emit('select', {
        card: randomCard,
        e: e
      });
    },
    _getRandomCard: function () {
      let rank = _.sample(['a', 'k', 'q', 'j', 't', '9', '8', '7', '6']);
      let suit = _.sample(constants.suits);

      return rank + suit;
    },
    toggle: function () {
      $(this.$el).find('.dropdown-toggle').dropdown('toggle');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/mixins";

  .short-deck-individual-card-selector {
    @include noselect;
    display: inline-block;

    .dropdown-toggle {
      vertical-align: middle;
      display: block;
      width: 34px;
      height: 44px;
      border: 1px solid lightgray;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .dropdown-menu {
      padding: 10px;
      margin-left: auto;
      margin-right: auto;

      table {
        border-spacing: 5px;
        border-collapse: separate;

        td {
          img {
            cursor: pointer;
            width: 100%;
          }
        }
      }
    }

    .mobile {
      display: none;

      .btn-block {
        margin-bottom: 15px;
      }
    }

    .non-mobile {
      width: 700px;
      max-width: 95vw;

      .btn-block {
        margin-top: 5px;
      }
    }

    .deselect {
      cursor: pointer;
      font-size: 18px;
      color: darkgray;
      margin-left: 11px;
    }

    @media (max-width: 991px) {
      & {
        .dropdown-toggle {
          width: 54px;
          height: 72px;
        }

        .deselect {
          font-size: 26px;
          color: darkgray;
          margin-left: 18px;
        }
      }

      .non-mobile {
        display: none;
      }

      .mobile {
        display: block;

        img {
          width: 60px;
          margin-right: 20px;
          margin-bottom: 10px;
        }

        td:last-child img {
          margin-right: 0;
        }
      }
    }

    @media (max-width: 359px) {
      .dropdown-menu .mobile img {
        width: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck/short-deck-individual-card-selector.vue